'use client';

import React from 'react';

export const useBodyClassName = (className: string, deps: any[] = []) => {
  React.useEffect(() => {
    const classNameList = className.split(' ');
    classNameList.map((item) => document.body.classList.add(item));

    return () => {
      classNameList.map((item) => document.body.classList.remove(item));
    };
  }, deps);
};
